


<div class="pre-loader" *ngIf="loading">
  <div class="load-icon">
    <div class="ring-load">
      <div class="circle"></div>
      <div class="pageload-icon"></div>
    </div>
  </div>
</div>

<div class="ox_hidden" id="Cemex_incidendes_id">
  <div class="row m-0">
    <div class="col-lg-3 col-md-4 col-12 p-0 eventSection card-scroll_main">
      <div class="lb-head">
        <div class="clearfix">
          <h6 class="no-m pull-left">Incidents</h6>
          <i data-toggle="modal" data-target="#filters" tooltip="Filters" placement="left" class="fas fa-filter pull-right"></i>
        </div>
      </div>
      <div class="card-scroll p-1 pt-0" style="height: calc(100vh - 80px);">
        <div class="row mt-2">
          <div class="col-12" id="Summary_multi_ddl">
            <label>Select Fleet</label>
            <!--<select class="form-control" name="selectFleet" [(ngModel)]="selectedFleetForFilter">
              <option value="" disabled>Select</option>
              @for(item of fleetList; track item.FleetId){
              <option [value]="item.Id" class="">{{item.Name}}</option>
              }

     </select>-->

            <ng-multiselect-dropdown [settings]="fleetDropdownSettings"
                                     [data]="fleetList"
                                     [placeholder]="'Select fleet'"
                                     [(ngModel)]="selectedFleet1"
                                     (onSelect)="onDataSelect($event, 'fleet')"
                                     (onDeSelect)="onDataUnSelect($event, 'fleet')"
                                     (onSelectAll)="onSelectAll($event, 'fleet')"
                                     (onDeSelectAll)="onUnSelectAll('fleet')"
                                     (ngModelChange)="onFleetSelectionChange()">

            </ng-multiselect-dropdown>
          </div>
          <div class="col-12 mt-1">
            <label>Category</label>
            <select class="form-control" [(ngModel)]="selectedCategoryForFilter">
              <option value="" disabled selected>Select</option>
              @for(item of classificationList; track item.Id){
              <option [value]="item.Id" class="">{{item.Classification}}</option>
              }

            </select>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-6 pr-05">
            <label>Date </label>
            <input type="text"
                   class="form-control"
                   placeholder="Select Date"
                   [(ngModel)]="DateSelectedForFilter"
                   [bsConfig]="bsConfig"
                   bsDatepicker />
          </div>
          <div class="col-6 pl-05">
            <label>Incident No</label>
            <input type="text" class="form-control" placeholder="Enter Incident No">
          </div>

         
        </div>
        <div class="row mt-1">
          <div class="col-12 mb-1">
            <label>Driver Name </label>
            <input type="text" class="form-control" placeholder="Enter Driver Name">
          </div>
          <div class="col-12">
            <label>VRN </label>
            <select class="form-control" [(ngModel)]="selectedVRNForFilters">
              <option value="" disabled selected>Select VRN</option>
              @for(item of vehiclesList; track item.VRN){
              <option [value]="item.DeviceIdentifier" class="">{{item.VRN}}</option>
              }
            </select>
          </div>



        </div>

      </div>
      <div class="livefoot">
        <div class="row no-m width_100pc">
          <div class="col-md-6">

          </div>
          <div class="col-md-6 text-right pr-0">
            <a class="btn btn-success">Apply</a>
          </div>
        </div>

      </div>
    </div>
    <div class="col-lg-9 bod_left pr-0 pl-0">
      <div class="lb-head-single col-12">
        <h6 class="d-inline">Statistics</h6>
        <i data-toggle="modal" data-target="#AddNew_Case" tooltip="Add New Case" placement="left"
           class="fas fa-plus-circle pull-right font_20" (click)="openAddNewCaseModal()"></i>
      </div>
      <div class="card-scroll p-0 pr-15" style="height: calc(100vh - 80px);">
        <div class="summarySection">
          <div class="row no-m">

            <div class="col-sm-12 col-12">
              @if(showSummaryComp){
              <div class="row">
                @for (item of classificationList;track item.Id){
                <div class="col-sm-3  col-3 no-p">
                  <div (click)="onCategoryClick(item.Classification)" class="panel p-3 position_rel"
                       style="cursor:pointer;"
              
                       >
                    <div class="far" [ngClass]="[item.iconClass, 'panelbg', item.statusClass]"></div>
                    <div class="panel-info">
                      <h4 class="panel-count">{{item.Id}}</h4>
                      <h4 class="panel-title">{{item.Classification}}</h4>
                    </div>

                    <i  class="view_catogry_icon cursor-pointer far fa-arrow-alt-circle-right view_icon cursor-pointer"> </i>
                  </div>
                </div>
                }
              </div>

              }
              @else{

              <div class="card-container">
               
                <app-categories *ngIf="activeCategory" [selectedCategory]="activeCategory"></app-categories>

              </div>

              }


            </div>
          </div>
        </div>
      </div>
      <div class="livefoot">
        <div class="row no-m width_100pc">
          <div class="col-md-11">

          </div>
          <div class="col-md-1 no-p text-right">
            <div class="back-button-container" *ngIf="!showSummaryComp">
              <button class="btn btn_dark_new" (click)="goToCategories()">
                <i class="bi bi-arrow-left-circle"></i> Back
              </button>
            </div>
          </div>
          <!--  <div class="col-md-6 text-right pr-0">
      <a class="btn btn-success">Apply</a>
    </div>-->
        </div>

      </div>
    </div>

  </div>
</div>

<div id="AddNew_Case" tabindex="-1" class="modal fade right" style="z-index: 1;" aria-modal="true" role="dialog">
  <div class="modal-dialog no-m" style="width: 27%;">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Add New Case</h6>
        <button type="button" data-dismiss="modal" aria-label="Close" class="close" (click)="closeCaseModal()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
     
      <div class="modal-body card-scroll">
        <div class="form-group">
          <label>Select Fleet</label>
          <select class="form-control" name="selectFleet" [(ngModel)]="selectedFleet">
            <option value="" disabled>Select Fleet</option>
            @for(item of fleetList; track item.FleetId){
            <option [value]="item.Id" class="">{{item.Name}}</option>
            }

          </select>
        </div>
        <div class="form-group">
          <label>Select VRN </label>
          <select class="form-control" [(ngModel)]="selectedVRN">
            <option value="" disabled selected>Select VRN</option>
            @for(item of vehiclesList; track item.VRN){
            <option [value]="item.DeviceIdentifier" class="">{{item.VRN}}</option>
            }
          </select>
        </div>
        <!-- <div class="form-group">
    <label>Case Name</label>
    <input type="text" name="case" [(ngModel)]="caseName" placeholder="Enter Case" class="form-control" />
  </div>-->
        <div class="form-group">
          <label>Select Category</label>
          <select class="form-control" [(ngModel)]="selectedCategory" name="category">
            <option value="" disabled>Select Category</option>
            @for(item of classificationList; track item.Id){
            <option [value]="item.Id" class="">{{item.Classification}}</option>
            }

          </select>
        </div>
        <div class="form-group">
          <label>Select Date</label>
          <!--  <input type="text"
    #datepickerInput="bsDatepicker"
    class="form-control"
    placeholder="Select Date"
    [(ngModel)]="caseDateSelected"
    [bsConfig]="bsCaseDateConfig"
    bsDatepicker
    container="body" />-->

          <input type="text"
                 class="form-control"
                 placeholder="Select Date"
                 [(ngModel)]="caseDateSelected"
                 [bsConfig]="bsCaseDateConfig"
                 bsDatepicker />

        </div>


        <div class="form-group row">
          <div class="col">
            <label>Hours</label>
            <select class="form-control" [(ngModel)]="eventHours">
              <option value="" disabled>HH</option>
              @for (h of hours; track h) {
              <option [value]="h">{{ h }}</option>
              }
            </select>
          </div>

          <div class="col">
            <label>Minutes</label>
            <select class="form-control" [(ngModel)]="eventMinutes">
              <option value="" disabled>MM</option>
              @for (m of minutes; track m) {
              <option [value]="m">{{ m }}</option>
              }
            </select>
          </div>

          <div class="col">
            <label>Seconds</label>
            <select class="form-control" [(ngModel)]="eventSeconds">
              <option value="" disabled>SS</option>
              @for (s of seconds; track s) {
              <option [value]="s">{{ s }}</option>
              }
            </select>
          </div>
        </div>
        <!-- <div class="form-group position-relative">
    <label>Alert ID</label>
    <div class="input-with-prefix">
      <span class="prefix">#</span>
      <input type="text"
             class="form-control alert-id-input"
             placeholder="Enter Alert Id"
             [(ngModel)]="alertId"
             [ngModelOptions]="{ standalone: true }"
             (input)="onInputChange($event)">
    </div>
  </div>-->
        <!-- Media Type Selection -->
        <div class="form-group">
          <label>Media Type</label>
          <div class="media-options d-flex gap-2">
            <label class="media-radio" *ngFor="let type of mediaTypes">
              <input type="radio"
                     name="mediaType"
                     [value]="type.value"
                     [(ngModel)]="selectedMediaType"
                     (change)="selectMediaType(type.value)" />
              <div class="media-content" [class.active]="selectedMediaType === type.value">
                <i class="" [ngClass]="type.icon"></i>
                <span>{{ type.label }}</span>
              </div>
            </label>
          </div>
        </div>

        <!-- Upload Method: Alert ID -->
        <!-- Alert ID Section -->
        <div *ngIf="selectedMediaType == 'media'" class="form-group">
          <div class="d-flex align-items-center mb-2">
            <input type="radio" name="uploadMethod" value="alert" [(ngModel)]="selectedUploadMethod" class="me-2 mt-0" />
            <label class="mb-0"><strong>Alert ID</strong></label>
          </div>

          <div [class.disabled-section]="selectedUploadMethod !== 'alert'">
            <div class="input-group">
              <span class="input-group-text px-3" style="height:30px;">#</span>
              <input type="text"
                     class="form-control"
                     placeholder="Enter Alert Id"
                     [(ngModel)]="alertId"
                     [disabled]="selectedUploadMethod !== 'alert'" />
              <button type="button"
                      class="btn btn-outline-primary"
                      style="height:30px;"
                      (click)="fetchAlertData()"
                      [disabled]="selectedUploadMethod !== 'alert'">
                Fetch
              </button>
            </div>
          </div>
        </div>

        <!-- OR Separator -->
        <div class="or-separator" *ngIf="selectedUploadMethod === 'alert'">
          <div class="line"></div>
          <div class="or-text">OR</div>
          <div class="line"></div>
        </div>



        <div class="user_request_bod">
          <label class="d-flex align-items-center">
            <input type="radio" name="uploadMethod" value="request" [(ngModel)]="selectedUploadMethod" class="mr-05" />
            <strong> User Request Video</strong>
          </label>

          <div [class.disabled-section]="selectedUploadMethod !== 'request'" class="mt-0">
            <div class="row">
              <div class="col-md-12  mb-1">
                <label>VRN</label>
                <select class="form-control" [(ngModel)]="requestVRN" [disabled]="selectedUploadMethod !== 'request'">
                  <option *ngFor="let v of vrnList" [value]="v.DeviceIdentifier">{{ v.VRN }}</option>
                </select>
              </div>
              <div class="col-md-5">
                <label>Date</label>
                <!--   <input type="date" class="form-control"
    [(ngModel)]="requestDate"
    [disabled]="selectedUploadMethod !== 'request'" />-->
                <input type="text"
                       class="form-control"
                       placeholder="Select Date"
                       [(ngModel)]="requestDate"
                       [bsConfig]="bsConfig"
                       bsDatepicker
                       [disabled]="selectedUploadMethod !== 'request'" />
              </div>
              <div class="col-md-4 pl-0">
                <label>Time</label>
                <input type="time" class="form-control"
                       [(ngModel)]="requestTime"
                       [disabled]="selectedUploadMethod !== 'request'" />
              </div>
              <div class="col-md-3 pl-0">
                <div *ngIf="selectedUploadMethod == 'request'">
                  <label style="visibility:hidden;">Request</label>
                  <button class="btn btn-sm btn-success">Request</button>
                </div>
              </div>
            </div>
          </div>
         
        </div>

        <div class="or-separator">
          <div class="line"></div>
          <div class="or-text">OR</div>
          <div class="line"></div>
        </div>

        <!-- Upload Method: Drag and Drop -->
        <div class="upload-option">
          <label class="d-flex align-items-center">
            <input type="radio" name="uploadMethod" value="upload" [(ngModel)]="selectedUploadMethod" class="mr-05" />
            <strong> Drag & Drop Upload</strong>
          </label>

          <div [class.disabled-section]="selectedUploadMethod !== 'upload'" class="mt-2">
            <div class="upload-box"
                 (drop)="onDrop($event)"
                 (dragover)="onDragOver($event)"
                 (dragleave)="onDragLeave($event)"
                 [class.dragover]="isDragging"
                 [class.disabled-box]="selectedUploadMethod !== 'upload'">

              <div class="upload-content">
                <i class="fa fa-upload upload-icon"></i>
                <p>Drag and Drop files here</p>
                <p>or</p>
                <label for="fileInput" class="browse-link">Browse files</label>
                <input type="file" id="fileInput" hidden (change)="onFilesSelected($event)" multiple [disabled]="selectedUploadMethod !== 'upload'" />
              </div>

              <div class="upload-preview mt-2" *ngIf="uploadedFiles.length > 0">
                <p *ngFor="let file of uploadedFiles">{{ file.name }}</p>
              </div>
            </div>
          </div>
        </div>



      </div>
          <div class="livefoot row no-gutters">
            <div class="col">
              <button type="submit" class="btn btn-success float-right mr-1 cursor-pointer"
                      (click)="submitForm()">Submit</button>
            </div>
          </div>
    </div>
  </div>
</div>
<div id="filters" tabindex="-1" class="modal fade right" style="z-index: 1;" aria-modal="true" role="dialog">
  <div class="modal-dialog no-m" style="width: 27%;">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Filters</h6>
        <button type="button" data-dismiss="modal" aria-label="Close" class="close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <form novalidate="" name="createreqform" class="">
        <div class="modal-body card-scroll">
          <div class="form-group">
            <label>Empty</label>
            <input placeholder="" type="text" required="" class="form-control ">
          </div>
        </div>
        <div class="livefoot row no-gutters">
          <div class="col">
            <button type="submit" class="btn btn-success float-right mr-1" disabled="">Apply</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
